const accessInventory = {

    BRAND_LIST: { name: 'Brand', path: '/brand-list' },
    ADD_BRAND: { name: 'Create Brand', path: '/create-brand' },
    UPDATE_BRAND: { name: 'Edit Brand', path: '/edit-brand' },
    DELETE_BRAND: { name: 'Delete Brand', path: '/delete-brand' },

    SUB_CATEGORY_LIST: { name: 'Sub Category', path: '/sub-category-list' },
    ADD_SUB_CATEGORY: { name: 'Create Sub Category', path: '/create-sub-category' },
    UPDATE_SUB_CATEGORY: { name: 'Edit Sub Category', path: '/edit-sub-category' },
    DELETE_SUB_CATEGORY: { name: 'Delete Sub Category', path: '/delete-sub-category' },

    ITEM_LIST: { name: 'Item', path: '/item-list' },
    ADD_ITEM: { name: 'Create Item', path: '/create-item' },
    UPDATE_ITEM: { name: 'Edit Item', path: '/edit-item' },
    ITEM_DETAILS: { name: 'Item Details', path: '/item-details' },
    DELETE_ITEM: { name: 'Delete Item', path: '/delete-item' },

    MEASURE_UNIT_LIST: { name: 'Measure Unit', path: '/measure-unit-list' },
    ADD_MEASURE_UNIT: { name: 'Create Measure Unit', path: '/create-measure-unit' },
    UPDATE_MEASURE_UNIT: { name: 'Edit Measure Unit', path: '/edit-measure-unit' },
    DELETE_MEASURE_UNIT: { name: 'Delete Measure Unit', path: '/delete-measure-unit' },

    MEASURE_UNIT_TYPE_LIST: { name: 'Measure Unit Type', path: '/measure-unit-type-list' },
    ADD_MEASURE_UNIT_TYPE: { name: 'Create Measure Unit Type', path: '/create-measure-unit-type' },
    UPDATE_MEASURE_UNIT_TYPE: { name: 'Edit Measure Unit Type', path: '/edit-measure-unit-type' },
    DELETE_MEASURE_UNIT_TYPE: { name: 'Delete Measure Unit Type', path: '/delete-measure-unit-type' },

    PRODUCT_PRICING_LIST: { name: 'Product Pricing', path: '/product-pricing-list' },
    UPDATE_PRODUCT_PRICING: { name: 'Edit Product Pricing', path: '/edit-product-pricing' },

    CUSTOMER_PRICING_LIST: { name: 'Customer Pricing', path: '/customer-pricing-list' },
    UPDATE_CUSTOMER_PRICING: { name: 'Edit Customer Pricing', path: '/edit-customer-pricing' },

    CUSTOMER_CATEGORY_PRICING_LIST: { name: 'Customer Category Pricing', path: '/customer-category-pricing-list' },
    UPDATE_CUSTOMER_CATEGORY_PRICING: { name: 'Edit Customer Category Pricing', path: '/edit-customer-category-pricing' },

    COLOR_LIST: { name: 'Color', path: '/color-list' },
    ADD_COLOR: { name: 'Create Color', path: '/create-color' },
    UPDATE_COLOR: { name: 'Edit Color', path: '/edit-color' },
    DELETE_COLOR: { name: 'Delete Color', path: '/delete-color' },

    SEGMENT_LIST: { name: 'Segment', path: '/segment-list' },
    ADD_SEGMENT: { name: 'Create Segment', path: '/create-segment' },
    UPDATE_SEGMENT: { name: 'Edit Segment', path: '/edit-segment' },
    DELETE_SEGMENT: { name: 'Delete Segment', path: '/delete-segment' },

    RACK_LIST: { name: 'Rack', path: '/rack-list' },
    ADD_RACK: { name: 'Create Rack', path: '/create-rack' },
    UPDATE_RACK: { name: 'Edit Rack', path: '/edit-rack' },
    DELETE_RACK: { name: 'Delete Rack', path: '/delete-rack' },

    CREATE_DELIVERY_NOTE: { name: 'Create Delivery Note', path: '/create-delivery-note' },
    DELIVERY_NOTE_LIST: { name: 'Delivery Note', path: '/delivery-note-list' },
    PROOF_OF_DELIVERY: { name: 'Proof of Delivery', path: '/proof-of-delivery' },

    PAYMENT_LIST: { name: 'Payment', path: '/payment-list' },
    ADD_PAYMENT: { name: 'Create Payment', path: '/create-payment' },
    PAYMENT_APPROVAL: { name: 'Payment Approval', path: '/payment-approval' },

    INVOICE_LIST: { name: 'Invoice', path: '/invoice-list' },
    ADD_INVOICE: { name: 'Create Invoice', path: '/create-invoice' },
    PAYMENT_HISTORY: { name: 'Payment History', path: '/payment-history' },

    STOCK_REJECT: { name: 'Stock Reject', path: '/stock-reject' }
}

export default accessInventory;